import React from "react"
import * as styles from "./Styles/LampWidget.module.scss"
import "../styles/layouts.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import logo from "../images/lamp/logo.png"
import TrafficLightWidget from "./Common/TrafficLightWidget"

const LampWidget = (props) => {
  return (
    <div
      style={props.styles}
      className={cn(
        "l-flex",
        "l-flex-align-center",
        "l-flex--column",
        "l-text-center",
        "lampWidget"
      )}
    >
      {props.displayName == 1 && (
        <React.Fragment>
          <div className={styles.header}>
            <span className={styles.placeName}>{props.place.name}</span>
            <span>の混雑ランプ</span>
          </div>
          <hr className={styles.titleHr} />
        </React.Fragment>
      )}
      <div
        className={cn("l-flex", "l-centering", "l-flex--column", "lampBody")}
      >
        {props.lamp.available && props.place.lampRemark && (
          <div className={styles.lampRemark}>{props.place.lampRemark}</div>
        )}
        <div>
          <TrafficLightWidget currentColor={props.lamp.color} />
        </div>
        <div
          className={cn(
            "lampMessage",
            props.lamp.available ? `lampMessage--${props.lamp.color}` : ""
          )}
        >
          <span>{props.lamp.message}</span>
          {props.lamp.available && (
            <span className={styles.updated}>{props.lamp.description}</span>
          )}
        </div>
      </div>
      <div className={styles.locoguide}>
        <a href={props.place.path} target="_blank">
          <span>Powered by</span>
          <img src={logo} alt="ロコガイド" />
        </a>
      </div>
    </div>
  )
}

export default LampWidget
